import React from "react";
import "../css/Loading.css";

const Fail = () => {
    return (
        <div className="fail-container">
            <h2>Oops! Something went wrong...</h2>
            <p>We were unable to submit your form. Please try again later.</p>
        </div>
    );
};

export default Fail;
